//* Libraries imports
import { FaFileAlt, FaEdit, FaTrashAlt } from "react-icons/fa";
import { motion } from "framer-motion"; 
import styles from "../_components/styles/process-actions.module.scss";

//* Components imports
import Icon from "../../../../components/common/Icon";

type ProcessActionsProps = {
  processId: number;
  onViewClick?: () => void;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
  hideEdit?: boolean;
  hideDelete?: boolean;
};

export function ProcessActions({
  processId,
  onViewClick,
  onEditClick,
  onDeleteClick,
  hideEdit = false,
  hideDelete = false,
}: ProcessActionsProps) {
  const buttonVariants = {
    hover: { scale: 1.1, transition: { duration: 0.2 } },
    tap: { scale: 0.9 },
  };

  return (
    <div className={styles.actionsContainer}>
      {onViewClick && (
        <motion.div
          variants={buttonVariants}
          whileHover="hover"
          whileTap="tap"
          className={`${styles.actionButton} ${styles.viewButton}`}
          onClick={onViewClick}          title="Visualizar processo"
          role="button"
          aria-label="Visualizar processo"
        >
          <Icon icon={FaFileAlt} size={20} />
        </motion.div>
      )}
      
      {!hideEdit && onEditClick && (
        <motion.div
          variants={buttonVariants}
          whileHover="hover"
          whileTap="tap"
          className={`${styles.actionButton} ${styles.editButton}`}
          onClick={onEditClick}          title="Editar processo"
          role="button"
          aria-label="Editar processo"
        >
          <Icon icon={FaEdit} size={20} />
        </motion.div>
      )}
      
      {!hideDelete && onDeleteClick && (
        <motion.div
          variants={buttonVariants}
          whileHover="hover"
          whileTap="tap"
          className={`${styles.actionButton} ${styles.deleteButton}`}
          onClick={onDeleteClick}          title="Excluir processo"
          role="button"
          aria-label="Excluir processo"
        >
          <Icon icon={FaTrashAlt} size={20} />
        </motion.div>
      )}
    </div>
  );
}
